import React from 'react';
import DynamicAddButton from "../DynamicAddButton";

export default function AddSingleItemUi(props) {
  let {product, dispatch, flavour} = props;
  if (!product) return null;

  // skip displaying sku when we have the dummy button for google
  return (
    <div className="py-4">
      <DynamicAddButton dispatch={dispatch}
        className="text-xl w-full"
        product={product} flavour={flavour}/>
    </div>
  );
}


